import { render, staticRenderFns } from "./PostcodeSearch.vue?vue&type=template&id=31ead5a3&"
import script from "./PostcodeSearch.vue?vue&type=script&lang=js&"
export * from "./PostcodeSearch.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports